export enum ShipmentIntegrationActions {
  Create = 'create',
  Cancel = 'cancel',
  Assign = 'assign',
  CheckInGate = 'checkInGate',
  RequestPOD = 'requestPOD',
  SubmitPOD = 'submitPOD',
  Track = 'track',
  Details = 'getDetails',
  Update = 'update',
  Status = 'getStatus',
}
